const routes = [
  {
    path: '/me',
    name: 'Organization',
    component: () => import('src/components/ContentManager/index.vue'),
    children: [
      {
        name: 'OrgDashboardRoute',
        path: 'org',
        component: () => import('src/components/Organization/index.vue'),
        meta: { title: 'Dashboard' },
      },
      {
        name: 'OrgSettingsRoute',
        path: 'org/settings',
        component: () =>
          import('src/components/Organization/SettingsPage/index.vue'),
        meta: { title: 'Settings' },
      },
      {
        name: 'OrgSpacesRoute',
        path: 'org/spaces',
        component: () =>
          import('src/components/Organization/ListSpaces/index.vue'),
        meta: { title: 'Spaces' },
      },
      {
        name: 'OrgActivitiesRoute',
        path: 'org/activities',
        props: { isOrg: true },
        component: () =>
          import('src/components/ContentManager/ListActivities/index.vue'),
        meta: { title: 'Activities' },
      },
      {
        name: 'OrgFlowMotionRoute',
        path: 'org/flowmotion',
        component: () =>
          import('src/components/Organization/FlowMotionPage/index.vue'),
        meta: { title: 'FlowMotion', fullWidth: true },
      },
      {
        name: 'OrgSpaceDetailsRoute',
        path: 'org/spaces/:spaceId',
        component: () =>
          import(
            'src/components/Organization/ListSpaces/SpaceDetails/index.vue'
          ),
      },
      {
        name: 'OrgExtensionsRoute',
        path: 'org/apps',
        component: () =>
          import('src/components/Organization/ExtensionsPage/index.vue'),
        meta: { title: 'Extensions' },
      },
      // the title of this page is set on the mounted hook of BaseExtensionEditPage component
      {
        name: 'OrgExtensionEditRoute',
        path: 'org/apps/:extensionId/edit',
        component: () =>
          import(
            'src/components/Organization/ExtensionsPage/ExtensionEdit/index.vue'
          ),
      },
      {
        name: 'OrgTeamRoute',
        path: 'org/team',
        component: () =>
          import('src/components/Organization/TeamPage/index.vue'),
        meta: { title: 'User Management' },
      },
      {
        name: 'OrgFieldTypesRoute',
        path: 'org/fields',
        component: () =>
          import('src/components/Organization/FieldTypesPage/index.vue'),
        meta: { title: 'Fieldtypes' },
      },
      {
        name: 'OrgFieldTypeEditor',
        path: 'org/fields/:fieldId',
        component: () =>
          import('src/components/Organization/FieldTypesEditor/index.vue'),
        meta: { title: 'Fieldtypes Editor' },
      },
    ],
  },
]

export default routes
